module.exports = __webpack_public_path__ + "static/honeycrispapples-f3cb7988953fea47de9d8f721736e213.jpg";